import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router";
import app from "../../core/application";

/** 
 * This is a wrapper for Route which will only render the given route if the user is logged in.
 * If the user is not logged in they will be redirected to '/login' instead.
 */
class PrivateRoute<T extends RouteProps> extends React.Component<T, any>{

    public render() {

        if (app().userSession) {
            return <Route {...this.props} />;
        }

        const qs = window.location.pathname !== "/" ? `?from=${window.location.pathname}` : "";
        return <Redirect to={`/login${qs}`} />
    }
}

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/Routing/PrivateRoute.tsx